export const RECENT_ACTIVITIES_PAGE_NAME = 'recentActivities';
export const ACCOUNT_DETAILS_LIST = 'accountDetailsList';
export const CONTACT_DETAILS_LIST = 'contactDetailsList';
